<template>
  <dara-single-content-layout v-loading="fullscreenLoading" container-size="lg">
    <template #content>
      <dara-row class="mb-5">
        <dara-col>
          <dara-header>{{ $t('settings') }}</dara-header>
          <dara-p class="dara-u-text--medium">
            {{ $t('settings-text') }}
          </dara-p>

          <dara-form v-if="user" v-slot="{ validate }" :submit="updateUser">
            <ul class="nav nav-tabs mt-4 mb-4">
              <li class="nav-item">
                <a
                  class="nav-link"
                  :class="{ 'active' : showProfile }"
                  @click="onShowProfile">{{ $t('profile') }}</a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  :class="{ 'active' : showPreferences }"
                  @click="onShowPreferences">{{ $t('preferences') }}</a>
              </li>
            </ul>

            <dara-setting-profile-form v-if="showProfile" />
            <dara-setting-preferences-form v-if="showPreferences" />
            <div class="mt-4 mb-2 d--flex justify-content-end">
              <dara-button
                class="btn btn-secondary"
                width="110"
                size="sm"
                @click="goToBasePage()">
                {{ $t('cancel') }}
              </dara-button>
              <dara-button
                native-type="submit"
                class="btn btn-success ms-2"
                width="110"
                size="sm"
                @click="validate">
                {{ $t('save') }}
              </dara-button>
            </div>
          </dara-form>
        </dara-col>
      </dara-row>
    </template>
  </dara-single-content-layout>
</template>

<script>
import { getters } from '@/modules/user/user.store';
import { toastError, toastSuccess } from '@/services/toastService';
import { updateUserInformation, updateUserPreferences, uploadUserImage, deleteUserImage } from '@/modules/user/user.service';
import { translate, setLanguage } from '@/services/translate.service';
import { goToBasePage } from '@/router/route.service';

import DaraSettingProfileForm from '@/modules/setting/components/SettingProfileForm.vue';
import DaraSettingPreferencesForm from '@/modules/setting/components/SettingPreferencesForm.vue';
import DaraSingleContentLayout from '@/layouts/SingleContentLayout.vue';

export default {
  name: 'DaraSettingsPage',
  components: {
    DaraSettingProfileForm,
    DaraSettingPreferencesForm,
    DaraSingleContentLayout,
  },
  provide() {
    const userEditVm = {};
    Object.defineProperty(userEditVm, 'user', {
      get: () => this.user,
    });
    return { userEditVm };
  },
  data() {
    return {
      user: null,
      showProfile: true,
      showPreferences: false,
      fullscreenLoading: false,
      changedProfilePic: false,
      oldLanguage: null,
    };
  },
  mounted() {
    this.fetchUserInfo();
  },
  methods: {
    goToBasePage,
    fetchUserInfo() {
      this.user = { ...getters.getUser() };
      this.user.password = null;
      this.user.uploadFile = null;
      this.oldLanguage = this.user.language;
    },
    updateUser() {
      if (this.user.password) {
        const specialChars = !!(this.user.password.match(/[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]+/) && this.user.password.match(/\d+/));
        if (!specialChars) {
          toastError(`${translate('password-must-have-special-chars-and-numbers')}`);
          return false;
        }
      }

      if (this.user.password && this.user.password !== this.user.password2) {
        toastError(`${translate('passwords-doesnt-match')}`);
      } else if (this.user.uploadFile) {
        this.fullscreenLoading = true;
        this.changedProfilePic = true;
        uploadUserImage(this.user.uploadFile).then(data => {
          if (this.user.profile_pic != null) {
            const oldImageName = this.user.profile_pic.replace(/(https:\/\/storage.googleapis.com\/assets-dara\/)/gm, '');
            this.user.profile_pic = data.url;
            this.updateUserData();
            deleteUserImage(oldImageName);
          } else {
            this.user.profile_pic = data.url;
            this.updateUserData();
          }
        }).catch(() => {
          toastError(translate('error-uploading-new-image'));
          this.fullscreenLoading = false;
        });
      } else {
        this.fullscreenLoading = true;
        this.updateUserData();
      }
      return true;
    },
    updateUserData() {
      updateUserInformation(this.user)
        .then(() => {
          updateUserPreferences(this.user)
            .then(() => {
              this.fullscreenLoading = false;
              setLanguage(this.user.language);
              toastSuccess(`${translate('user-successfully-saved')}`);
              if (this.changedProfilePic || this.oldLanguage !== this.user.language) {
                setTimeout(() => {
                  this.$router.go();
                }, 300);
              }
            })
            .catch(() => {
              this.fullscreenLoading = false;
              toastError(`${translate('error-on-updating-users-preferences')}`);
            });
        })
        .catch(() => {
          this.fullscreenLoading = false;
          toastError(`${translate('error-on-updating-users-profile')}`);
        });
    },
    onShowProfile() {
      this.showProfile = true;
      this.showPreferences = false;
    },
    onShowPreferences() {
      this.showProfile = false;
      this.showPreferences = true;
    },
  },
};
</script>
